<template>
  <modal
    :show="show"
    footer-classes="justify-content-center"
    type="notice"
    @close="close"
  >
    <h5 slot="header" class="modal-title">A copier</h5>
    <template>
      <slot />
    </template>
    <div slot="footer" class="justify-content-center d-flex">
      <p-button
        type="success"
        round
        aria-label="Copier"
        @click.native="$emit('copy')"
        >Copier</p-button
      >
      <span>&nbsp;</span>
      <p-button
        type="light"
        round
        aria-label="fermer"
        @click.native="$emit('cancel')"
        >Fermer</p-button
      >
    </div>
  </modal>
</template>

<script>
import { Modal } from 'src/components/UIComponents';

export default {
  name: 'ClipboardModal',
  components: {
    Modal,
  },
  props: ['show'],
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
